import React, { useEffect } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Flex } from "antd";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PhotoGallerySection } from "~/schemas/generated/graphql";
import { Field } from "~/shared/ui/Field";

const defaultValues = {
  title: "",
  description: "",
};

type PhotoGalleryFormData = {
  title: string;
  description: string;
};

interface PhotoGalleryFormProps {
  currentItem?: PhotoGallerySection;
  onSubmit: (data: PhotoGalleryFormData) => void;
  formId: string;
}

const PhotoGalleryForm = ({
  currentItem,
  onSubmit,
  formId,
}: PhotoGalleryFormProps) => {
  const { t } = useTranslation();

  const schema = yup.object().shape({
    title: yup.string().required(t("validation.required")),
    description: yup.string().required(t("validation.required")),
  });

  const { handleSubmit, control, errors, setValue, reset } =
    useForm<PhotoGalleryFormData>({
      defaultValues,
      resolver: yupResolver(schema),
    });

  useEffect(() => {
    if (currentItem) {
      setValue("title", currentItem.title);
      setValue("description", currentItem.description);
    } else {
      reset();
    }
  }, [currentItem]);

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <Flex vertical gap={10}>
        <Field
          type="input"
          name="title"
          control={control}
          label={t("photoGallery.table.title")}
          error={errors["title"]?.message}
        />
        <Field
          type="textarea"
          name="description"
          control={control}
          label={t("photoGallery.table.description")}
          error={errors["description"]?.message}
        />
      </Flex>
    </form>
  );
};

export default PhotoGalleryForm;
